import { render, staticRenderFns } from "./OurServiceAI.vue?vue&type=template&id=fb65c228&scoped=true"
import script from "./OurServiceAI.vue?vue&type=script&lang=js"
export * from "./OurServiceAI.vue?vue&type=script&lang=js"
import style0 from "./OurServiceAI.vue?vue&type=style&index=0&id=fb65c228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb65c228",
  null
  
)

export default component.exports